import i18next from 'i18next';

export type AppLocale = 'zh-CN' | 'en-US';
const localeStorageKey = 'nest.locale';

const readLocale = (): AppLocale => {
  try {
    return localStorage.getItem(localeStorageKey) === 'en-US'
      ? 'en-US'
      : 'zh-CN';
  } catch {
    return 'zh-CN';
  }
};

export const locale = readLocale();
const catalogs = import.meta.glob<Record<string, string>>(
  '../locales/en/*.json',
  {
    eager: true,
    import: 'default',
  },
);
const i18n = i18next.createInstance();
void i18n.init({
  lng: locale,
  fallbackLng: 'zh-CN',
  supportedLngs: ['zh-CN', 'en-US'],
  initAsync: false,
  keySeparator: false,
  nsSeparator: false,
  resources: {
    'zh-CN': { translation: {} },
    'en-US': {
      translation: Object.fromEntries(
        Object.values(catalogs).flatMap(Object.entries),
      ),
    },
  },
  interpolation: { escapeValue: false },
});

export const t = i18n.t.bind(i18n);

export const changeLocale = (next: AppLocale): void => {
  if (next === locale) return;
  localStorage.setItem(localeStorageKey, next);
  // Reload also rebuilds module-level validation schemas and clears localized query caches.
  window.location.reload();
};

if (typeof document !== 'undefined') document.documentElement.lang = locale;
